<script>
import {
  // FacebookIcon,
  // InstagramIcon,
  // TwitterIcon,
  // LinkedinIcon,
  MailIcon,
} from "vue-feather-icons";
import axios from "axios";
import { API_URL, MEDIA_URL } from "@/core/api";
export default {
  data() {
    return {
      // isCondensed: false,
      apiUrl: API_URL,
      auth: localStorage.getItem("id_token") !== null ? true : false,
      recruiter:
        localStorage.getItem("user") !== null &&
        JSON.parse(localStorage.getItem("user")).role == "Direct Employer"
          ? true
          : false,
      jobSeeker:
        localStorage.getItem("user") !== null &&
        JSON.parse(localStorage.getItem("user")).role == "Job Seeker"
          ? true
          : false,
      isCondensed: false,
    };
  },
  components: {
    // FacebookIcon,
    // InstagramIcon,
    // TwitterIcon,
    // LinkedinIcon,
    MailIcon,
  },
  mounted() {
    var link = !!document.querySelector("link[rel='canonical']")
      ? document.querySelector("link[rel='canonical']")
      : document.createElement("link");
    link.setAttribute("rel", "canonical");
    link.setAttribute(
      "href",
      location.protocol + "//" + location.host + location.pathname
    );
    document.head.appendChild(link);
    axios.get(`${this.apiUrl}/get-top-job-cities`).then((response) => {
      this.cities = response.data;
    });
  },
  methods: {
    toggleMenu() {
      this.isCondensed = !this.isCondensed;
      if (this.isCondensed) {
        document.getElementById("navigation").style.display = "block";
      } else document.getElementById("navigation").style.display = "none";
    },
    search(item) {
      // console.log(item);
      this.$router.replace({
        path: "/jobs/Pakistan/" + item.city_name,
        params: {
          search_text: this.search_text,
          selected_cities: [{ id: 1, value: item.city_name }],
        },
      });
    },
  },
};
</script>

<template>
  <div class="mt-17">
    <div>
      <Navbar />
    </div>
    <!--end header-->
    <!-- Navbar End -->
    <div class="login_image_bg">
      <div class="container" style="margin: 0 auto">
        <div
          class="login login-1"
          :class="{
            'login-signin-on': this.state == 'signin',
          }"
          id="kt_login"
        >
          <div class="row align-items-center">
            <!--begin::Aside-->
            <div class="col-lg-4 auth_heading">
              Welcome <span class="font-weight-bolder"> Back..!</span>
            </div>
            <!--begin::Aside-->
            <!--begin::Content-->
            <div
              class="col-lg-5 col-md-6 bg-white p-9 px-10 border Small"
            >
              <div class="">
                <div class="">
                  <div class="login-form login-signin">
                    <form
                      class="form"
                      novalidate="novalidate"
                      id="kt_login_signin_form"
                      @submit.stop.prevent="onSubmitLogin()"
                    >
                      <div class="pt-lg-0 pt-5">
                        <div class="card-title auth_title">
                          <h1 class="auth_title">Forgotten Password</h1>
                          <p
                            class="text-muted text-center"
                            style="font-size: 12px"
                          >
                            Enter your email to reset your password
                          </p>
                        </div>
                      </div>
                      <div class="form-group">
                        <div
                          id="example-input-group-1"
                          label=""
                          label-for="example-input-1"
                          class="form-group auth_inputs_img position-relative"
                        >
                          <img
                            src="/images/login_contact/usernameemail.svg"
                            alt=""
                          />
                          <input
                            class="form-control fieldch"
                            type="text"
                            name="email"
                            placeholder="Enter Email Adderss"
                            ref="email"
                            v-model="form.email"
                          />
                        </div>
                      </div>

                      <div class="pb-lg-0 pb-5">
                        <button
                          ref="kt_login_signin_submit"
                          class="btn submitBnt"
                        >
                          Reset Password
                        </button>
                      </div>
                      <div class="hr_blue"></div>
                      <div
                        class="text-muted text-center"
                        style="font-size: 13px !important"
                      >
                        Remamber your password?
                        <a
                          id=""
                          class="text-primary font-weight-bolder"
                          href="/login"
                        >
                          Login</a
                        >
                      </div>
                    </form>
                  </div>
                </div>
                <!--begin::Content footer-->
                <div class="text-center pt-8">
                  <a
                    href="/terms-and-conditions"
                    class="font-weight-bold font-size-h6"
                    >Terms</a
                  >
                  <a
                    href="/recruiter"
                    class="ml-10 font-weight-bold font-size-h6"
                    >Plans</a
                  >
                  <a
                    href="/contact-us"
                    class="ml-10 font-weight-bold font-size-h6"
                    >Contact Us</a
                  >
                </div>
                <!--end::Content footer-->
              </div>
            </div>
            <!--end::Content-->
          </div>
        </div>
      </div>
    </div>
    <div>
      <!-- Footer Start -->
      <Footer />
      <!-- Footer End -->
      <Switcher />
      <!-- Back to top -->
      <a
        href="javascript: void(0);"
        class="btn btn-icon btn-soft-primary back-to-top"
        id="back-to-top"
        v-scroll-to="'#topnav'"
      >
        <arrow-up-icon class="icons"></arrow-up-icon>
      </a>
      <!--end footer-->
    </div>
  </div>
</template>

<!-- Load login custom page styles -->
<style lang="scss">
@import "@/assets/sass/pages/login/login-1.scss";
</style>

<script>
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";

// FormValidation plugins
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import SubmitButton from "@/assets/plugins/formvalidation/dist/es6/plugins/SubmitButton";
import Switcher from "@/view/front/components/switcher";
import Footer from "@/view/front/components/footer";
import Navbar from "@/view/front/components/navbar";

import KTUtil from "@/assets/js/components/util";
import { mapGetters, mapState } from "vuex";
import { LOGIN, LOGOUT, REGISTER } from "@/core/services/store/auth.module";
import Swal from "sweetalert2";
import axios from "axios";
import { API_URL } from "@/core/api";
import { initFbsdk } from "@/core/config/facebook.js";

export default {
  name: "login-1",
  data() {
    return {
      state: "signin",

      form: {
        email: "",
        password: "",
      },

      apiUrl: API_URL,
    };
  },
  computed: {
    ...mapState({
      errors: (state) => state.auth.errors,
    }),
    ...mapGetters(["currentUser"]),

    backgroundImage() {
      return (
        process.env.BASE_URL + "media/svg/illustrations/login-visual-1.svg"
      );
    },
  },
  mounted() {
    var link = !!document.querySelector("link[rel='canonical']")
      ? document.querySelector("link[rel='canonical']")
      : document.createElement("link");
    link.setAttribute("rel", "canonical");
    link.setAttribute(
      "href",
      location.protocol + "//" + location.host + location.pathname
    );
    document.head.appendChild(link);
    initFbsdk();
    const signin_form = KTUtil.getById("kt_login_signin_form");

    this.fv1 = formValidation(signin_form, {
      fields: {
        email: {
          validators: {
            notEmpty: {
              message: "Email is required",
            },
            emailAddress: {
              message: "The value is not a valid email address",
            },
          },
        },
      },
      plugins: {
        trigger: new Trigger(),
        submitButton: new SubmitButton(),
        bootstrap: new Bootstrap(),
      },
    });
  },
  components: {
    Navbar,
    Switcher,
    Footer,
  },
  methods: {
    showForm(form) {
      // console.log("test");
      this.state = form;
      var form_name = "kt_login_" + form + "_form";
      KTUtil.animateClass(
        KTUtil.getById(form_name)
        // "animate__animated animate__backInUp"
      );
    },

    onSubmitLogin() {
      this.fv1.validate();
      this.fv1.validate().then((res) => {
        if (res == "Valid") {
          const submitButton = this.$refs["kt_login_signin_submit"];
          submitButton.classList.add(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
          let formData = new FormData();
          formData.append("email", this.form.email);

          axios.post(`${API_URL}/pass-forgot`, formData).then((data) => {
            console.log(data);
            const submitButton = this.$refs["kt_login_signin_submit"];
            submitButton.classList.remove(
              "spinner",
              "spinner-light",
              "spinner-right"
            );
            if (data.data === "Email has been sent") {
              Swal.fire({
                title: "",
                text:
                  "To verify your account” it should be “to reset your password",
                icon: "success",
                confirmButtonClass: "btn btn-secondary",
                heightAuto: false,
              }).then(function() {
                window.location = "/set-password";
              });
            } else {
              if (data.data === "No Email") {
                Swal.fire({
                  title: "",
                  text: "We have not found account on this mail.",
                  icon: "error",
                  confirmButtonClass: "btn btn-secondary",
                  heightAuto: false,
                });
              } else {
                Swal.fire({
                  title: "",
                  text:
                    "Have some issues please contact with job4u.pk sport team",
                  icon: "error",
                  confirmButtonClass: "btn btn-secondary",
                  heightAuto: false,
                });
              }
            }
          });
        } else {
          const submitButton = this.$refs["kt_login_signin_submit"];
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
          Swal.fire({
            title: "",
            text: "Please, provide correct data!",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
        }
      });

      // console.log("login hit ht"),
      this.fv.on("core.form.invalid", () => {
        Swal.fire({
          title: "",
          text: "Please, provide correct data!",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
      });
    },
  },
};
</script>
<style scoped>
footer span,
footer a,
footer p,
footer h4,
footer label {
  color: white !important;
}
</style>
